"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_FUNCTIONS_KEY = exports.ADD_EDIT_DOSSIER_FILES = exports.ADD_EDIT_DOSSIER_EVENTS = void 0;
exports.ADD_EDIT_DOSSIER_EVENTS = 'Add/Edit Dossier Events';
exports.ADD_EDIT_DOSSIER_FILES = 'Add/Edit Dossier Files';
exports.USER_FUNCTIONS_KEY = 'userFunctions';
